import IconButton from "material-ui/IconButton";

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/uielements/iconbutton/index.js